import { render, staticRenderFns } from "./AgentSessionList.vue?vue&type=template&id=1f83a7bc&scoped=true&"
import script from "./AgentSessionList.vue?vue&type=script&lang=js&"
export * from "./AgentSessionList.vue?vue&type=script&lang=js&"
import style0 from "./AgentSessionList.vue?vue&type=style&index=0&id=1f83a7bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83a7bc",
  null
  
)

export default component.exports